module.exports = __webpack_public_path__ + "./ChiehPhoto_684d094cdf4d95a5657253a5d906c7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/ChiehPhoto.png
// module id = 521
// module chunks = 0